<template>
  <div class="report-box">
    <div class="list-box">
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <p>{{item.name}}</p>
          <div class="childen-box" v-for="(child, i) in item.childen" :key="i">
            <span>{{child.name}}</span><span class="btn" @click="downBtn">付费下载</span>
          </div>
        </li>
      </ul>
      <el-dialog
        :visible.sync="dialogVisible"
        width="400px"
        center
        :before-close="handleClose">
        <div class="mian-box" v-if="isshow">
          <p>该方案购买需要支付：20元</p>
          <p>充值金额：20元</p>
          <p>充值方式：支付宝扫码</p>
        </div>
        <div class="img-box" v-else>
          <p>￥20.00</p>
          <img src="../../assets/zfb.png" alt="">
          <p>支付宝扫码支付</p>
        </div>
        <span slot="footer" class="dialog-footer" v-if="isshow">
          <el-button type="primary" @click="confirmBtn">确定并支付</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      list: [
        {
          name: '店铺产品流量管理方案',
          childen: [
            {
              name: '（一）店铺流量管理方案-产品优化预动作'
            },{
              name: '（二）店铺流量管理方案-产品增加曝光量'
            },{
              name: '（三）店铺流量管理方案-产品提高点击率'
            },
          ]
        },{
          name: '爆款产品管理方案',
          childen: [
            {
              name: '（一）爆款产品管理方案-爆款生命周期管理'
            },{
              name: '（二）爆款产品管理方案-爆款盈利阶段规划'
            },{
              name: '（三）爆款产品管理方案-爆款暴毙风险防范'
            },
          ]
        },{
          name: '店铺定位规划方案',
          childen: [
            {
              name: '（一）店铺定位规划方案-选择蓝海行业'
            },{
              name: '（二）店铺定位规划方案-筛选优质产品'
            },{
              name: '（三）店铺定位规划方案-产品打造包装'
            },
          ]
        }
      ],
      dialogVisible: false,
      isshow: true
    }
  },
  created(){

  },
  methods:{
    downBtn(){
      this.dialogVisible = true
    },
    handleClose(){
      this.dialogVisible = false
      setTimeout(() =>{
        this.isshow = true
      },500);
    },
    confirmBtn(){
      this.isshow = false
    }
  }
}
</script>
<style lang="scss" scoped>
.report-box{
  width: 1200px;
  background: #ffffff;
  margin: 30px auto;
  .list-box{
    padding: 20px 150px 40px 30px;
    li{
      font-size: 18px;
      margin: 15px 0;
      line-height: 24px;
      text-align: left;
      .childen-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0;
      }
      .btn{
        cursor: pointer;
        color: #00aaee;
      }
    }
  }
  .mian-box{
    font-size: 16px;
    p{
      margin-bottom: 20px;
    }
  }
  .img-box{
    text-align: center;
    font-size: 20px;
    p{
      margin: 20px 0;
    }
    img{
      width: 200px;
      height: 200px;
    }
  }
}
</style>